import "core-js/modules/es6.array.slice.js";
import { STATUS_NAME } from '~/const/orders';
var display = function display(label1) {
  var label2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return label1 ? "<br>".concat(label2, " ").concat(label1) : '';
};
export var capitalize = function capitalize(name) {
  return name && "".concat(name[0].toUpperCase() + name.slice(1).toLowerCase());
};
export var formatAddress = function formatAddress(_ref) {
  var address = _ref.address,
    address2 = _ref.address2,
    zipcode = _ref.zipcode,
    city = _ref.city,
    countryLabel = _ref.countryLabel,
    phone = _ref.phone,
    company = _ref.company,
    comment = _ref.comment;
  return "\n  ".concat(address, "\n  ").concat(display(address2), "\n  ").concat(display(city, zipcode), "\n  ").concat(display(countryLabel), "\n  ").concat(display(phone), "\n  ").concat(display(company), "\n  ").concat(display(comment), "\n");
};
export var formatUserName = function formatUserName() {
  var civility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var firstname = arguments.length > 1 ? arguments[1] : undefined;
  var lastname = arguments.length > 2 ? arguments[2] : undefined;
  return "".concat(civility, " ").concat(capitalize(firstname), " ").concat(capitalize(lastname));
};
export var getStepperColorByShipmentStatus = function getStepperColorByShipmentStatus(label) {
  switch (label) {
    case STATUS_NAME.REQUESTING_PAYEMENT:
      return 'hsl(25, 70%, 53%)';
    case STATUS_NAME.APOINTEMENT:
      return 'hsl(25, 70%, 53%)';
    case STATUS_NAME.CANCELED:
      return 'hsl(3, 61%, 46%)';
    case STATUS_NAME.PAYMENT_CASH_DESK_ERROR:
      return 'hsl(3, 61%, 46%)';
    default:
      return 'hsl(84, 57%, 47%)';
  }
};